import { combineReducers, createStore } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import { composeWithDevTools } from "redux-devtools-extension";

import storage from "redux-persist/lib/storage";

import data from "./core-module/data/reducers";
import services from "./core-module/services/reducers";

const rootReducer = combineReducers({
  data: data,
  services: services
});

const persistConfig = {
  key: "root",
  storage: storage,
  blacklist: ["data"]
};

export const persistanceOn = true;

const pReducer = persistanceOn
  ? persistReducer(persistConfig, rootReducer)
  : rootReducer;

const store =
  process.env.NODE_ENV === "development"
    ? createStore(pReducer, composeWithDevTools())
    : createStore(pReducer);

export const persistor = persistanceOn ? persistStore(store) : null;

export default store;
